import { FC } from 'react';
import { twMerge } from 'tailwind-merge';
import Switch from '../switch/switch';
import Text from '../text/text';

export interface CollapsableToggleHeadI {
    id: string;
    checked: boolean;
    onChange(value: boolean): void;
    label: string;
    testId?: string;
    disabled?: boolean;
    className?: string;
}
const CollapsableToggleHead: FC<CollapsableToggleHeadI> = ({
    id,
    checked = false,
    onChange,
    label,
    className,
    testId,
    disabled = false,
}) => {
    return (
        <div
            className={twMerge('bg-white w-full h-12 flex justify-start items-center', className)}
            data-test-id={testId}
        >
            <Switch
                id={`grand-toggle-${id}`}
                checked={checked}
                disabled={disabled}
                onChange={() => onChange(!checked)}
                className="mr-2 ml-5"
            />
            {label && (
                <Text family="poppins" weight="semibold" size="14" lineHeight="20">
                    {label}
                </Text>
            )}
        </div>
    );
};

export default CollapsableToggleHead;
